var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

  var myElements = document.getElementsByClassName( "bsscommerce-password-form");


  
  for (i = 0; i < myElements.length; i++) {
    var check_form = myElements[i];
    //console.log($(this).attr('style'));
  }
  //$('.bsscommerce-password-form').attr('style') == 'display: block;')

  let searchParams = new URLSearchParams(window.location.search);
  console.log(searchParams);
  if(searchParams.has('_key')){
      let param = searchParams.get('_key');

    if(param == '1b9311b70870e87eea9a4f1de684feeb7a2721ffd6276fd6c263ebca563bc9e3'){
      console.log('matching key');
                $('span[class="bsscommerce-password-form"]').each(function(index,item){
        
              if($(item).attr('style') == 'display: block;'){
                console.log($(item).attr('style'));
                //var password_input = $("#bsscommerce-password");
                var password_input = $(item).find("#bsscommerce-password");
                var password_btn = $(item).find("#bsscommerce-password-submit");
                $(password_input).attr("value","green");
                $(password_btn).trigger('click');
                //console.log($(item).find("#bsscommerce-password").attr( "value" ));
              }
            
          });
    }else{
      console.log('no matching key');
    }

    
  }else{
    console.log('no param');
  }
    /*
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
        console.log('parameter: ' + sParameterName[0]);
        if (sParameterName[0] === sParam) {

          $('span[class="bsscommerce-password-form"]').each(function(index,item){
        
              if($(item).attr('style') == 'display: block;'){
                console.log($(item).attr('style'));
                var password_input = $(item).find("#bsscommerce-password");
                var password_btn = $(item).find("#bsscommerce-password-submit");
                $(password_input).attr("value","green");
                $(password_btn).trigger('click');
              }
            
          });


        }
    }
    */
    return false;
};


var key = getUrlParameter('_key');
